<template>
  <timeline-item type="SMS" :date="message.date_sent">
    <template v-slot:body>{{ message.content }}</template>
  </timeline-item>
</template>

<script>
import TimelineItem from "@/components/timeline/TimelineItem";

export default {
  name: "SmsMessage",
  components: {TimelineItem},
  props: ['message'],
}
</script>

<style scoped>

</style>
